import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeDeleteVacancyModal, fetchDeleteVacancy, selectIsDeleteVacancyModalOpen, selectOnDelete } from "../../model"

export const DeleteVacancyModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsDeleteVacancyModalOpen)
    const onDelete = useAppSelector(selectOnDelete)

    const handleClose = () => {
        dispatch(closeDeleteVacancyModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchDeleteVacancy())
                .unwrap()
                .then(() => {
                    notify.success('Вакансия успешно удалена')
                    reset()
                    onDelete?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Удаление вакансии"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите удалить выбранную вакансию?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Удалить
                    </button>
                </div>
            </form>
        </Modal>
    )
}